import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { EyeIcon } from "@heroicons/react/24/outline";
import { EyeSlashIcon } from "@heroicons/react/24/outline";
import Input from "../../../components/forms/Input/Input";

export default function ResetForm({ onSubmit, error, loading, links }) {
  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const [t] = useTranslation();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm();

  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="pt-28 flex justify-center bg-slate-200 h-screen">
      <div className="flex flex-col gap-2 rounded-md border border-gray-300 bg-white p-8 h-fit">
        <h2 className="text-4xl font-bold mb-4 text-center text-primary w-80">
          {t("signup.reset_password")}
        </h2>
        <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
          <Input
            errorMsg={errors?.iin?.message}
            inputClassName={`bg-white shadow-none outline-1 outline-gray-300 md:rounded-lg h-10 ${
              errors?.iin?.message && "ring-error ring-1"
            }`}
            className="w-80 text-sm"
            label={t("auth.iin")}
            placeholder={t("auth.enter_iin")}
            type="text"
            name="iin_ana_tili_bil"
            required
            {...register("iin", {
              required: t("auth.iin_required"),
              maxLength: 12,
              pattern: {
                value: /^[0-9]+$/,
                message: t("auth.invalid_iin"),
              },
            })}
          />
          <div className="flex flex-row relative">
            <Input
              errorMsg={errors?.password?.message}
              inputClassName={`bg-white shadow-none outline-1 outline-gray-300 md:rounded-lg h-10 ${
                errors?.password?.message && "ring-error ring-1"
              }`}
              className="w-80 text-sm"
              label={t("welcome.password")}
              placeholder={t("signup.enter_password")}
              type={isVisible ? "text" : "password"}
              required
              {...register("password", {
                required: t("auth.password_required"),
                maxLength: 64,
                validate: (value) => {
                  const errors = [];
                  if (value?.length < 8)
                    errors.push(t("signup.password_error.err_1"));
                  if (!/[A-Z]/.test(value))
                    errors.push(t("signup.password_error.err_2"));
                  if (!/[a-z]/.test(value))
                    errors.push(t("signup.password_error.err_3"));
                  if (!/\d/.test(value))
                    errors.push(t("signup.password_error.err_4"));
                  if (value === watch("email"))
                    errors.push(t("signup.password_error.err_5"));

                  return errors.length > 0 ? errors.join("\n") : true;
                },
              })}
            />
            <div className="absolute right-2 top-7 cursor-pointer text-primary">
              {isVisible ? (
                <EyeIcon className="h-5" onClick={() => setIsVisible(false)} />
              ) : (
                <EyeSlashIcon
                  className="h-5"
                  onClick={() => setIsVisible(true)}
                />
              )}
            </div>
          </div>
          <div className="flex flex-row relative">
            <Input
              errorMsg={errors?.confirmPassword?.message}
              inputClassName={`bg-white shadow-none outline-1 outline-gray-300 md:rounded-lg h-10 ${
                errors?.confirmPassword?.message && "ring-error ring-1"
              }`}
              className="w-80 text-sm"
              label={t("welcome.confirm_password")}
              placeholder={t("auth.enter_confirm_password")}
              type={isVisibleConfirm ? "text" : "password"}
              required
              {...register("confirmPassword", {
                required: t("auth.confirm_password_required"),
                maxLength: 64,
                validate: (value) => {
                  if (value !== watch("password"))
                    return t("signup.confirm_password_error");
                },
              })}
            />{" "}
            <div className="absolute right-2 top-7 cursor-pointer text-primary">
              {isVisibleConfirm ? (
                <EyeIcon
                  className="h-5"
                  onClick={() => setIsVisibleConfirm(false)}
                />
              ) : (
                <EyeSlashIcon
                  className="h-5"
                  onClick={() => setIsVisibleConfirm(true)}
                />
              )}
            </div>
          </div>

          <div className="rounded-lg overflow-hidden mt-2">
            <Button
              className="w-full text-base font-semibold"
              text={t("signup.reset_password")}
              color="primary"
              type="submit"
              loading={loading}
              disabled={loading}
            />
          </div>
        </form>

        {error && (
          <div className="text-red-500 mx-auto text-center">{error}</div>
        )}

        <div className="border-t border-gray-300"></div>

        {links.map((link) => (
          <div
            key={link.text}
            onClick={link.onClick}
            className="text-center text-primary underline-none cursor-pointer"
          >
            {link.text}
          </div>
        ))}
      </div>
    </div>
  );
}
